import { motion } from "framer-motion"
import { graphql } from "gatsby"
import { GatsbyImage, getImage } from "gatsby-plugin-image"
import React from "react"
import FadeInWhenVisible from "src/components/animated/FadeInWhenVisible"
import Layout from "src/components/Layout"
import * as styles from "src/styles/project-details.module.scss"

export default function ProjectDetails({ data }) {
  const { html } = data.project
  const { title, thumb } = data.project.frontmatter

  const Gallery = () => {
    if (data.gallery.nodes.length > 0) {
      return (
        <FadeInWhenVisible>
          <div>
            <h2>Gallery</h2>
            <div className={styles.gallery}>
              {data.gallery.nodes.map(image => (
                <motion.div
                  whileHover={{ scale: 1.5, zIndex: 1 }}
                  key={image.id}
                >
                  <GatsbyImage
                    className={styles.image}
                    image={getImage(image)}
                    alt="Gallery Image"
                  />
                </motion.div>
              ))}
            </div>
          </div>
        </FadeInWhenVisible>
      )
    } else {
      return <div></div>
    }
  }

  return (
    <Layout>
      <div className={["container", styles.details].join(" ")}>
        <h1 className="heading">{title}</h1>
        <div className={styles.featured}>
          <GatsbyImage image={getImage(thumb)} alt="" />
        </div>
        <div
          className={styles.html}
          dangerouslySetInnerHTML={{ __html: html }}
        />

        <Gallery />
      </div>
    </Layout>
  )
}

export const query = graphql`
  query Project($slug: String, $gallery: String) {
    project: markdownRemark(frontmatter: { slug: { eq: $slug } }) {
      html
      frontmatter {
        title
        gallery
        thumb {
          childImageSharp {
            gatsbyImageData
          }
        }
      }
    }
    gallery: allFile(filter: { relativeDirectory: { eq: $gallery } }) {
      nodes {
        id
        childImageSharp {
          gatsbyImageData
          id
        }
      }
    }
  }
`
